import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
 #SIDE-MENU-ITEM
\*------------------------------------ */
/**
 * 1) Item within side menu that can contain icons and an after slot for items like badges
 */
:host {
  display: contents;
}

/**
 * Side menu item
 */
.cat-c-side-menu__item {
  position: relative;
  width: 100%;
  border-block-end: var(--cat-border-width-sm) solid var(--cat-theme-color-border-subtle);
  /**
  * setting default bg-color for all states in mobile for cat-c-side-menu__item
  **/
  /**
   * Side menu item within first cat-side-menu-item wrapper
   */
  /**
   * Side menu item within last cat-side-menu-item wrapper
   * 1) Remove any margin from last item
   */
}
.cat-c-side-menu__item.cat-is-disabled {
  cursor: not-allowed;
}
.cat-c-side-menu__item.cat-is-mobile {
  border-block-end-color: var(--cat-theme-color-border-strong-hover);
  background-color: var(--cat-theme-color-content-strong);
}
.cat-c-side-menu__item.cat-is-mobile:hover, .cat-c-side-menu__item.cat-is-mobile:focus {
  background-color: var(--cat-theme-color-content-strong);
}
:host(:first-of-type) .cat-c-side-menu__item {
  margin-block-start: 1px;
}
:host(:last-of-type) .cat-c-side-menu__item {
  margin-block-end: 0; /* 1 */
}
.cat-c-side-menu__item:not(.cat-is-mobile) {
  border: none;
  margin-block-end: var(--cat-side-menu-item-margin-bottom, 1px);
}

/**
* color for all list items inside side menu item for mobile
**/
.cat-c-side-menu__item.cat-is-mobile ::slotted(cat-list) {
  color: var(--cat-theme-color-content-knockout);
}
.cat-c-side-menu__item.cat-is-mobile ::slotted(cat-list):hover, .cat-c-side-menu__item.cat-is-mobile ::slotted(cat-list):focus {
  color: var(--cat-theme-color-content-knockout);
}

/**
 * Side menu item inner container
 */
.cat-c-side-menu__item-inner {
  display: flex;
}

/**
 * Side menu link
 */
.cat-c-side-menu__link {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  display: flex;
  flex-direction: var(--cat-side-menu-link-flex-direction, row);
  position: relative;
  align-items: var(--cat-side-menu-link-align-items, baseline);
  width: 100%;
  padding-block: var(--cat-side-menu-link-padding-block-start, calc(var(--size-base-unit) * 1.75)) var(--cat-side-menu-link-padding-block-end, calc(var(--size-base-unit) * 1.75));
  padding-inline: var(--cat-side-menu-link-padding-inline-start, calc(var(--size-base-unit) * 2)) var(--cat-side-menu-link-padding-inline-end, calc(var(--size-base-unit) * 2));
  text-transform: inherit;
  letter-spacing: inherit;
  background: transparent;
  text-align: var(--cat-side-menu-link-text-align, start);
  appearance: none;
  outline: none;
  border: none;
  color: var(--cat-theme-color-content-default);
  text-decoration: none;
  cursor: pointer;
  transition: color var(--cat-anim-fade-quick) var(--cat-anim-ease), background var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
  * Side menu link within current item
  */
  /**
  * Side menu link within current item in the collapsed state
  */
  /**
  * color for isActive and isCurrent and bg-color for states in cat-c-side-menu__link
  **/
}
.cat-c-side-menu__link:hover {
  background: var(--cat-theme-color-background-default-hover);
}
.cat-c-side-menu__item:not(.cat-is-mobile) .cat-c-side-menu__link:hover {
  color: var(--cat-theme-color-content-default);
}
.cat-c-side-menu__link:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, -2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  background: var(--cat-theme-color-background-default-hover);
}
.cat-c-side-menu__item:not(.cat-is-mobile) .cat-c-side-menu__link:focus-visible {
  color: var(--cat-theme-color-content-default);
}
.cat-c-side-menu__link:before {
  content: "";
  display: block;
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  height: 100%;
  width: 4px;
  background-color: transparent;
  transition: background-color var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-is-collapsed .cat-c-side-menu__link {
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
}
.cat-c-side-menu__item:not(.cat-is-mobile) .cat-c-side-menu__link {
  padding-block: var(--cat-side-menu-link-padding-block-start, calc(var(--size-base-unit) * 2.125)) var(--cat-side-menu-link-padding-block-end, calc(var(--size-base-unit) * 2.125));
  padding-inline: var(--cat-side-menu-link-padding-inline-start, calc(var(--size-base-unit) * 3)) var(--cat-side-menu-link-padding-inline-end, calc(var(--size-base-unit) * 3));
}
.cat-c-side-menu__item.cat-is-active:not(.cat-is-mobile) .cat-c-side-menu__link {
  color: var(--cat-theme-color-content-strong);
}
.cat-c-side-menu__item.cat-is-current .cat-c-side-menu__link:before {
  background-color: var(--cat-theme-color-background-brand);
}
.cat-c-side-menu__item.cat-is-current:not(.cat-is-mobile) .cat-c-side-menu__link, .cat-c-side-menu__item.cat-is-active:not(.cat-is-mobile) .cat-c-side-menu__link {
  font-family: var(--cat-theme-typography-label-lg-font-family);
  font-weight: var(--cat-theme-typography-label-lg-font-weight);
  font-size: var(--cat-theme-typography-label-lg-font-size);
  line-height: var(--cat-theme-typography-label-lg-line-height);
  color: var(--cat-theme-color-content-default);
  background: var(--cat-theme-color-background-default-hover);
}
.cat-c-side-menu__item.cat-is-current.cat-is-collapsed:not(.cat-is-mobile) .cat-c-side-menu__link, .cat-c-side-menu__item.cat-is-active.cat-is-collapsed:not(.cat-is-mobile) .cat-c-side-menu__link {
  font-family: var(--cat-theme-typography-footnote-bold-font-family);
  font-weight: var(--cat-theme-typography-footnote-bold-font-weight);
  font-size: var(--cat-theme-typography-footnote-bold-font-size);
  line-height: var(--cat-theme-typography-footnote-bold-line-height);
}
.cat-c-side-menu__item.cat-is-disabled .cat-c-side-menu__link {
  color: var(--cat-theme-color-content-disabled);
  background: var(--cat-theme-color-background-default);
  pointer-events: none;
}
.cat-c-side-menu__item.cat-is-disabled .cat-c-side-menu__link .cat-c-side-menu__after {
  opacity: 0.337;
}
.cat-c-side-menu__item.cat-is-mobile .cat-c-side-menu__link {
  color: var(--cat-theme-color-content-knockout);
  font-family: var(--cat-theme-typography-title-sm-font-family);
  font-weight: var(--cat-theme-typography-title-sm-font-weight);
  font-size: var(--cat-theme-typography-title-sm-font-size);
  line-height: var(--cat-theme-typography-title-sm-line-height);
}
.cat-c-side-menu__item.cat-is-mobile .cat-c-side-menu__link:hover, .cat-c-side-menu__item.cat-is-mobile .cat-c-side-menu__link:focus {
  background-color: var(--cat-theme-color-content-strong);
}
.cat-c-side-menu__item.cat-is-current.cat-is-mobile .cat-c-side-menu__link, .cat-c-side-menu__item.cat-is-active.cat-is-mobile .cat-c-side-menu__link {
  color: var(--cat-color-brand-cat-yellow);
}
.cat-c-side-menu__item.cat-is-disabled.cat-is-mobile .cat-c-side-menu__link {
  color: var(--cat-theme-color-content-disabled);
  background-color: var(--cat-theme-color-content-strong);
}

/**
 * Side menu icon
 * 1) Only pull in these values when side menu is collapsed
 */
.cat-c-side-menu__text {
  white-space: var(--cat-side-menu-text-white-space);
  text-overflow: var(--cat-side-menu-text-text-overflow);
  overflow: var(--cat-side-menu-text-overflow);
  width: 100%;
}

/**
 * Side menu icon
 */
.cat-c-side-menu__icon {
  position: relative;
  margin-inline-end: var(--cat-side-menu-icon-margin-inline-end, calc(var(--size-base-unit) * 1.3125));
  margin-block-end: var(--cat-side-menu-icon-margin-block-end, 0);
}

/**
 * Side menu after
 */
.cat-c-side-menu__after {
  position: var(--cat-side-menu-after-position, relative);
  inset-block-start: var(--cat-side-menu-after-top);
  inset-inline-end: var(--cat-side-menu-after-right);
  margin-inline-start: auto;
}

/**
 * Side menu item panel
 * 1) Panel for cat-side-menu-sublist to go
 * 2) Span sub list items fully to the side menu border
 */
.cat-c-side-menu__item-panel {
  position: var(--cat-side-menu-item-panel-position, static);
  inset-block-start: 0;
  inset-inline-start: calc(100% + 1px);
  visibility: hidden;
  height: 0;
  overflow: hidden;
  min-width: var(--cat-side-menu-slotted-list-min-width, none);
  background: var(--cat-side-menu-item-panel-background, none);
  box-shadow: var(--cat-side-menu-item-panel-box-shadow, none);
  border-radius: var(--cat-side-menu-item-panel-border-radius, none);
  z-index: var(--cat-z-index-400);
  /**
   * Side menu item panel within expanded item
   * 1) Show the sublist(s) and set the height
   */
  /**
   * Side menu item panel when cat-is-collapsed
   */
}
.cat-c-side-menu__item.cat-is-active .cat-c-side-menu__item-panel {
  visibility: visible; /* 1 */
  height: auto; /* 1 */
  overflow: visible; /* 1 */
  padding-block: calc(var(--size-base-unit) * 0.125);
}
.cat-c-side-menu__item.cat-is-active.cat-is-collapsed .cat-c-side-menu__item-panel {
  padding: calc(var(--size-base-unit) * 0.5) calc(var(--size-base-unit) * 0.25);
}
.cat-c-side-menu__item:not(.cat-is-mobile) .cat-c-side-menu__item-panel {
  margin-inline-end: var(--cat-side-menu-item-panel-margin-inline-end, 0);
  color: inherit;
  --cat-list-item-link-hover-background: var(--cat-theme-color-background-default-hover);
}
.cat-is-collapsed.cat-c-side-menu__item.cat-is-active:not(.cat-is-mobile) .cat-c-side-menu__item-panel {
  overflow-y: auto;
  max-height: var(--cat-side-menu-item-panel-height, 100vh);
  margin: 0;
}

.cat-c-side-menu__item-right {
  margin-inline-start: auto;
}

/**
 * Side menu items icon
 * 1) Accordion icon that signifies open/closed in expanded state
 */
.cat-c-side-menu__items-icon {
  display: var(--cat-side-menu-items-icon-display, block);
  position: relative;
  margin-inline-start: calc(var(--size-base-unit) * 1);
  transition: transform var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
   * Side menu items icon within expanded state
   * 1) Rotate the icon to signify it is expanded
   */
}
.cat-c-side-menu__item.cat-is-active .cat-c-side-menu__items-icon {
  transform: rotate(-180deg); /* 1 */
}
`;
       